module.exports = __webpack_public_path__ + "img/error.673fc0d6.svg";